import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CustomerOrProviderSearchViewModel } from "src/erp/arap/rawData/customerOrProviderSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { CustomerTurnOverView } from "./customerTurnOver-view"
import { translate } from "src/common/utilities";

export class CustomerTurnOverViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("customerTurnOver-viewModel.accountTurnover", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.customerId = '';
        this.lineItems = ObservableArray.create<lineItem>();
        this.customerSelector = new CustomerOrProviderSearchViewModel(this);
        this.customerSelector.onSelectionChanged = x => {
            this.customerName = x.name,
                this.customerCode = x.code;
            this.customerId = x.id;
        };
        this.from = moment.utc();
        this.until = moment.utc();
    }

    GetDefaultView(): View<ViewModel> {
        return new CustomerTurnOverView();
    }
    public getTypeId(): string {
        return "VM-2FB38928-D99B-4D0C-840A-D9B7DE48FC0E"
    }

    public set from(v: moment.Moment) {
        let v2 = v.clone().local().hour(0).minute(0).second(0).millisecond(0)
        this._from = v2;
    } public get from(): moment.Moment { return this._from; } private _from: moment.Moment;
    public set until(v: moment.Moment) {
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2;
    } public get until(): moment.Moment { return this._until; } private _until: moment.Moment;
    public set customerSelector(v: CustomerOrProviderSearchViewModel) { this._customerSelector = v; } public get customerSelector(): CustomerOrProviderSearchViewModel { return this._customerSelector; } private _customerSelector: CustomerOrProviderSearchViewModel;

    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode; } private _customerCode: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId; } private _customerId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems; } private _lineItems: ObservableArray<lineItem>;
    public set remaining(v: string) { this._remaining = v; } public get remaining(): string { return this._remaining; } private _remaining: string;

    async calculate() {
        if (this.customerId == '') {
            this.messageBoxConfirmWarning(translate("customerTurnOver-viewModel.customerError", {}), translate("customerTurnOver-viewModel.error", {}));
        } else {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('Complex/ArapServices/GetCustomerAccountTurnOver', {
                    From: this.from,
                    Until: this.until,
                    CustomerId: this.customerId
                });
                let turnOvers: lineItem[] = result.TurnOvers.map(x => {
                    let r = new lineItem(this);
                    r.date = moment.utc(x.Time);
                    r.currencyName = x.CurrencyName;
                    r.reason = x.Description;
                    r.transactionCode = x.TransactionCode;
                    if (x.Amount > 0) {
                        r.debt = `${x.Amount}`;
                        r.credit = '0';
                    } else {
                        r.debt = '0';
                        r.credit = `(${-x.Amount})`
                    }
                    if (x.Total < 0) {
                        r.remaining = `(${-x.Total})`
                    } else {
                        r.remaining = `${x.Total}`
                    }
                    return r;
                });
                var initial = new lineItem(this);
                initial.reason = translate("customerTurnOver-viewModel.remaining", {});
                initial.date = this.from;
                initial.currencyName = translate("customerTurnOver-viewModel.rial", {});
                if (result.InitialBalance > 0) {
                    initial.debt = `${result.InitialBalance}`;
                    initial.credit = '0';
                } else {
                    initial.debt = '0';
                    initial.credit = `(${-result.InitialBalance})`
                }
                if (result.InitialBalance < 0) {
                    initial.remaining = `(${-result.InitialBalance})`
                } else {
                    initial.remaining = `${result.InitialBalance}`
                }

                turnOvers.unshift(initial);
                if (result.FinalBalance < 0) {
                    this.remaining = `(${-result.FinalBalance})`;
                } else {
                    this.remaining = `${result.FinalBalance}`;
                }
                turnOvers.forEach((x, i) => {
                    x.index = i + 1;
                })
                this.lineItems.update(...turnOvers);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(translate("customerTurnOver-viewModel.operationErorr", {}), translate("customerTurnOver-viewModel.error", {}));
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class lineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason; } private _reason: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set debt(v: string) { this._debt = v; } public get debt(): string { return this._debt; } private _debt: string;
    public set credit(v: string) { this._credit = v; } public get credit(): string { return this._credit; } private _credit: string;
    public set remaining(v: string) { this._remaining = v; } public get remaining(): string { return this._remaining; } private _remaining: string;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode; } private _transactionCode: string;
    public set currencyName(v: string) { this._currencyName = v; } public get currencyName(): string { return this._currencyName; } private _currencyName: string;

}